import { Download } from 'lucide-react';
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from '@vwt/ui';
import { apiUrl } from '../lib/api-base.js';
import { useTranslation } from '../lib/i18n.js';

/** Downloads the current filters as a spreadsheet (same access as the list, up to 5000 rows). */
export function ExportMenu({ path, filters }: { path: string; filters: Record<string, string> }) {
  const { t } = useTranslation();
  const href = (format: 'csv' | 'xlsx') => {
    const query = new URLSearchParams(Object.entries(filters).filter(([k, v]) => v && k !== 'cursor' && k !== 'limit'));
    query.set('format', format);
    return apiUrl(`${path}?${query.toString()}`);
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="md" variant="secondary">
          <Download /> {t('work.export.title')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-60">
        <DropdownMenuLabel className="font-normal text-fg-subtle">{t('work.export.hint')}</DropdownMenuLabel>
        <DropdownMenuItem asChild>
          <a href={href('xlsx')} download>
            {t('work.export.xlsx')}
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href={href('csv')} download>
            {t('work.export.csv')}
          </a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
